// WhitelabelTurnstile — the captcha slot both white-label onboarding panes
// mount (WS-SHELL-PANES-RENDER-TURNSTILE-WIDGET-1).
//
// It is a SLOT, not a widget: Cloudflare renders its own iframe into this
// node. Everything imperative lives in `functions/whitelabelTurnstile.js`
// and is reached through `el.call`, so this file stays declarative.
//
// ── State contract (the pane owns the state; this element declares none) ──
//   reads  `onboardingCaptcha` — `{ provider, siteKey }` from
//          `GET /core/onboarding/options`, parked by the pane's own kick.
//          Absent ⇒ this element renders nothing at all.
//   writes `captchaToken`    — the single-use token the submit sends
//   writes `captchaWidgetId` — the id the submit resets after every attempt
//
// Declaring no `state:` is deliberate: the element must share the pane's
// state so the submit button (a sibling, not a child) reads the same token.
//
// ⚠️ Hostname allowlist: a Turnstile widget only issues a token on the
// hostnames configured on the widget itself. The shared key covers
// `localhost`, `symbo.ls` and `symbols.app` (subdomains included, so
// `*.pr.symbols.app` is covered). A customer's own domain must be added to
// the widget before the pane can get a token there.

const _siteKey = (s) => {
  const c = s && s.onboardingCaptcha
  return c && c.siteKey ? String(c.siteKey).trim() : ''
}

export const WhitelabelTurnstile = {
  tag: 'div',
  margin: 'V 0 0',
  // Both channels, like every other conditional row in these panes. `hide:`
  // is CSS-only in this runtime (a hidden node still exists and still runs
  // its lifecycle — the mount function gates on the site key itself, never
  // on visibility); `display` keeps a re-shown one from painting as a block
  // of empty space.
  hide: (el, s) => !_siteKey(s),
  display: (el, s) => (_siteKey(s) ? 'block' : 'none'),

  // Per-instance, non-reactive storage for the widget id + the site key it
  // was rendered for — the mount latch that keeps `onRender` + `onUpdate`
  // from stacking two widgets in one node.
  scope: { turnstileWidgetId: null, turnstileSiteKey: null },

  // The captcha config lands AFTER first paint (the options call is async),
  // so the mount must be attempted on both lifecycle points; the function
  // itself is idempotent per site key.
  onRender: (el, s) => el.call('mountWhitelabelTurnstile', { state: s }),
  onUpdate: (el, s) => el.call('mountWhitelabelTurnstile', { state: s }),
  onRemove: (el, s) => el.call('removeWhitelabelTurnstile', { state: s })
}
